// Geotab Dash Cams Domain Configuration
export const geotabDashcamsConfig = {
  // Basic domain information
  id: 'geotab-dashcams',
  name: 'Geotab Dash Cams',
  tagline: 'Premium Dash Cam Solutions by Geotab',
  description: 'High-quality dash cameras for professional drivers.',
  
  // Assets
  logo: '/assets/logos/geotab-dashcams-logo.png',
  whiteLogo: '/assets/logos/geotab-dashcams-white-logo.png',
  favicon: '/assets/favicons/geotab-dashcams-favicon.png',
  icon: '/assets/icons/geotab-dashcams',
  
  // Navigation
  pages: ['home', 'solutions', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy now'
  },
      
  // Shop link
  shopLink: 'https://shop.fleethoster.com/collections/geotab',

  // UI Configuration
  variant: 'grid',
  showFeatures: false,
  showTestimonials: false,
  
  // Content sections
  hero: {
    title: 'Geotab Dash Cams',
    subtitle: 'High-quality dash cameras for professional drivers',
    features: ['4K Recording', 'Night Vision', 'GPS Tracking']
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'Geotab Dash Cams and Solutions',
    subtitle: 'Explore our premium dash cameras and fleet safety solutions',
    description: 'See how Geotab DashCams transforms fleet safety with high-quality video technology'
  },

  features: {
    title: 'Geotab Dash Cam Features',
    subtitle: 'Comprehensive Dash Cam Solutions',
    description: 'Discover the powerful features that make Geotab dash cam solutions the best choice for your fleet management needs.',
    items: [
      {
        title: 'Real-time Monitoring',
        description: 'Monitor your fleet in real-time with comprehensive tracking and reporting capabilities.',
        icon: '📊'
      },
      {
        title: 'Advanced Analytics',
        description: 'Get insights with advanced analytics and reporting tools for better decision making.',
        icon: '📈'
      },
      {
        title: 'Easy Integration',
        description: 'Seamless integration with existing systems and third-party applications.',
        icon: '🔗'
      },
      {
        title: '24/7 Support',
        description: 'Round-the-clock support with dedicated customer service and technical assistance.',
        icon: '🆘'
      }
    ]
  },
  
  solutions: {
    title: 'Geotab Dash Cam Solutions',
    subtitle: 'Professional dash cameras for enhanced driver safety and fleet protection',
    description: 'Geotab\'s High-quality dash cameras designed specifically for fleet operations with advanced features and reliable performance.',
    sections: [
      {
        title: 'Critical events + video coaching in one',
        description: 'GO Focus Plus AI dash cam cuts wasted hours from review. High-risk actions, like fatigue, tailgating and hard braking, trigger instant in-cab voice alerts for drivers, helping build better habits in real time. For managers, the most critical events are surfaced first with video and context, making it easy to review urgent risks and coach effectively in one streamlined workflow. The system analyzes events right in the vehicle delivering faster alerts, keeping data secure and improving automatically with every use.'
      },
      {
        title: 'How GO Focus Plus cuts distracted driving risk',
        description: 'GO Focus Plus addresses distracted driving and other critical risks at every turn. Here\'s how each event moves from detection to improvement, to help your fleet prevent incidents before they happen. On-device computer vision detects risky driving behavior, like distracted driving, tailgating and hard braking. Events are analyzed on the device as they occur. An in-cab voice alert is instantly delivered to the driver. Drivers self-correct in real time, reducing risk before an incident takes place. High-severity or repeated risky events are automatically flagged to the fleet safety manager. Managers review video and event details, then assign targeted feedback or coaching through the built-in driver coaching workflow. Drivers review feedback and recommended actions in the mobile app, then apply safer driving practices on future trips.'
      },
      {
        title: 'Coaching workflow that makes every alert count',
        description: 'With GO Focus Plus, a critical event becomes a driver coaching opportunity inside MyGeotab. Managers see video context, risk level, and recommended next steps—all at a glance. Assign feedback, track driver progress, and recognize improvement with a workflow built for fleet realities. Severity-based dashboards surface the drivers and behaviors that need attention most, so managers act faster and close the loop on risk. Results stay visible, and safer driving habits take hold fleet-wide.'
      }
    ]
  },
  
  
  testimonials: [
    {
      content: "I don't know how we'd do it without Geotab – the solution is literally in every aspect of our operations.",
      author: "Jonathan Hamilton",
      role: "Director of Fleet Safety and Compliance",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/25.jpg"
    },
    {
      content: "We're excited about what's coming next. It just keeps getting better and better, working with their technology and continuing to evolve. It's been great.",
      author: "Christian Reisch",
      role: "Co-owner",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/20.jpg"
    }
  ],

  blog: {
    title: 'Geotab Dash Cams News & Insights',
    subtitle: '',
    description: 'Stay informed with the latest news and insights from the Geotab Dash Cams blog.',
  },
  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'Geotab Dash Cams - Premium Dash Cam Solutions',
    description: 'Fleet dash cam solution with reliable, high-quality, and user-friendly cameras, offering advanced safety features and fleet protection',
    keywords: [
      'Geotab dash cams', 'fleet cameras', 'driver safety', 'dash cam systems', 'fleet management',
      'premium dash cameras', '4K dash cams', 'fleet safety cameras', 'professional dash cameras', 'fleet monitoring',
      'Geotab dash camera systems', 'fleet camera solutions', 'driver protection', 'fleet safety systems',
      'dash cam technology', 'fleet video recording', 'professional camera systems', 'fleet security cameras', 'Geotab'
    ],
    
    // Open Graph & Social Media
    ogTitle: 'Geotab Dash Cams - Premium Dash Cam Solutions',
    ogDescription: 'High-quality dash cameras for professional drivers. 4K recording, night vision, GPS tracking.',
    ogType: 'website',
    ogUrl: 'https://www.geotabdashcams.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'Geotab Dash Cams - Premium Dash Cam Solutions',
    twitterDescription: 'High-quality dash cameras for professional drivers. 4K recording, night vision, GPS tracking.',
    
    // Robots
    robots: 'index, follow',
    author: 'Geotab Dash Cams',
    publisher: 'Geotab Dash Cams',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'Geotab Dash Cams - Premium Dash Cam Solutions',
        description: 'Fleet dash cam solution with reliable, high-quality, and user-friendly cameras, offering advanced safety features and fleet protection',
        keywords: ['Geotab dash cams', 'fleet cameras', 'driver safety', 'dash cam systems', 'fleet management']
      },
      solutions: {
        title: 'Geotab Dash Cams Solutions - Premium Fleet Safety Services',
        description: 'Comprehensive dash cam solutions and fleet safety services. Professional camera installation and advanced monitoring systems.',
        keywords: ['dash cam solutions', 'fleet safety services', 'camera installation', 'fleet monitoring']
      },
      products: {
        title: 'Geotab Dash Cams Products - Premium Dash Camera Equipment',
        description: 'Premium dash cam products and camera equipment. High-quality 4K cameras and advanced fleet safety technology.',
        keywords: ['dash cam products', 'camera equipment', '4K cameras', 'fleet safety technology']
      },
      blog: {
        title: 'Geotab Dash Cams News & Insights - Fleet Safety Blog',
        description: 'Latest news, insights, and best practices for dash cam technology and fleet safety. Professional tips and safety updates.',
        keywords: ['dash cam news', 'fleet safety insights', 'camera technology tips', 'driver safety best practices']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
